module.exports = __webpack_public_path__ + "img/courses_empty01.50c7abe.png";